const amount = (value) => Number(value) || 0;

/**
 * The amounts a term row shows once the term has been sent to the provider. Saving the schedule no
 * longer reaches such a term unless a super admin unlocks and edits it, so its fee, discount and
 * agreed stay what the server holds while the schedule's AUTO figures move on. The row shows those,
 * and its due and credit follow them, because every payment check uses them too.
 *
 * Returns null when the row should keep using the schedule.
 */
export const savedTermAmounts = (backendTerm, { unlocked = false } = {}) => {
  if (backendTerm?.sentToProvider !== true || unlocked || backendTerm.agreedAmount == null) {
    return null;
  }
  return {
    termFee: amount(backendTerm.perSemFee),
    materialFee: amount(backendTerm.materialFee),
    discount: amount(backendTerm.discount),
    agreed: amount(backendTerm.agreedAmount),
  };
};
